import { JsonProvider } from 'leaflet-geosearch';
import { OAuthService } from 'angular-oauth2-oidc';

import { AppConfig } from 'src/app/app.config';

export default class HpoAddressSearchProvider extends JsonProvider {


    constructor(private config: AppConfig, private oAuthService: OAuthService, options?: any) {
        super(options);
    }

    endpoint({ query, type }) {
        return this.getUrl(`${this.config.backendMapUri}/CommonMapWebAPI/api/GeoCode/Autocomplete`, {
            search: query,
            listall: true,
        });
    }

    parse({ data }) {
        // Note that `data` is the raw result returned by the server. This
        // method should return data in the SearchResult format.
        return data.map((x) => {
            let label = ''
            if (x.number && x.number != "0") {
                label = x.name + ' ' + x.number;
            } else {
                label = x.name;
            }
            label += ', ' + x.municipality;

            return {
                x: x.longitude,
                y: x.latitude,
                label: label,
                bounds: null,
                raw: x
            }
        }
        );
    }

    override async search(options: any): Promise<any[]> {
        const url = this.endpoint({
            query: options.query,
            type: 0,
        });


        const request = await fetch(url, {
            headers: {
                "Authorization": `Bearer ${this.oAuthService.getAccessToken()}`
            }
        });
        const json = await request.json();
        return this.parse({ data: json });
    }
}